import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent implements OnInit {
    message: string;
    name: string;
    clicked = false;
    icon;
    confirmButtons: boolean;
    constructor(public dialog: MatDialogRef<ConfirmDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
        this.message = data.message;
        this.name = data.name ? data.name : '';
        this.icon = data.icon || 'error';
        this.confirmButtons = data.confirmButtons ?? true;

        this.dialog.addPanelClass(data.class || 'info-alert');
    }

    ngOnInit(): void {}

    close() {
        this.dialog.close(null);
    }
    reject() {
        this.dialog.close(false);
    }

    confirm() {
        this.clicked = true;

        this.dialog.close(true);
    }
}
